import api from './api';

export interface Question {
  _id: string; // Added to match backend question._id
  question: string;
  options: string[];
  correctAnswer: string;
  timeToSolve: number;
}

export interface GenerateQuestionsResponse {
  success: boolean;
  questionSetId: string;
  totalTimeToSolve: number;
  expiresAt: string | null;
  user: {
    id: string;
    email: string;
    name: string;
  };
  questions: Omit<Question, 'correctAnswer'>[];
}

export interface ResultResponse {
  success: boolean;
  result: {
    totalQuestions: number;
    correctAnswers: number;
    incorrectAnswers: number;
    skippedQuestions: number;
    percentage: number;
    detailedResults: Array<{
      questionId: string;
      question: string;
      options: string[];
      correctAnswer: string;
      explanationToAnswer: string;
      userAnswer: string | null;
    }>;
    subject: string;
    feedback: string;
    topics: string[];
    Botfeedback: string;
    audioBase64: string;
  };
}

export interface MockTestUsageResponse {
  success: boolean;
  planName: string;
  hasActiveSubscription: boolean;
  dailyLimit: number;
  todayUsageCount: number;
  remainingCount: number;
  isLimitReached: boolean;
  usageDate: string;
}

export const generateQuestions = async (
  topics: string[],
  subject: string,
  feedback: string
): Promise<GenerateQuestionsResponse> => {
  try {
    const response = await api.post<GenerateQuestionsResponse>('/questions/generate', {
      topics,
      subject,
      feedback,
    });

    return response.data;
  } catch (error: any) {
    console.error('Error generating questions:', error?.response?.data || error.message);
    throw new Error('Failed to generate questions');
  }
};

export const getMockTestUsage = async (): Promise<MockTestUsageResponse> => {
  try {
    const response = await api.get<MockTestUsageResponse>('/questions/usage');
    return response.data;
  } catch (error: any) {
    console.error('Error fetching mock test usage:', error?.response?.data || error.message);
    throw new Error('Failed to fetch mock test usage');
  }
};

export const getResults = async (
  questionSetId: string,
  answers: Array<{ questionId: string; selectedOption: string | null }>
): Promise<ResultResponse> => {
  try {
    const response = await api.post<ResultResponse>('/questions/results', {
      questionSetId,
      answers,
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching results:', error?.response?.data || error.message);
    throw new Error('Failed to fetch results');
  }
};
